const cat = {
  categories: [
    {
      id: 1,
      category: "Promotions",
      href: "promotions",
    },
    {
      id: 2,
      category: "Rice",
      href: "rice",
    },
    {
      id: 3,
      category: "Dal",
      href: "dal",
    },
    {
      id: 4,
      category: "Salt",
      href: "salt",
    },
    {
      id: 5,
      category: "Spices",
      href: "spices",
    },
    {
      id: 6,
      category: "Masalas",
      href: "masalas",
    },
    {
      id: 7,
      category: "Flour",
      href: "flour",
    },
    {
      id: 8,
      category: "Oil",
      href: "oil",
    },
    {
      id: 9,
      category: "Noodles",
      href: "noodles",
    },

    {
      id: 10,
      category: "Milk",
      href: "milk",
    },
    {
      id: 11,
      category: "Sugar",
      href: "sugar",
    },
    {
      id: 12,
      category: "Biscuits",
      href: "biscuits",
    },
    {
      id: 13,
      category: "Tea & Coffee",
      href: "teacoffee",
    },
    {
      id: 14,
      category: "Pickles",
      href: "pickles",
    },
    {
      id: 15,
      category: "Sauces",
      href: "sauces",
    },
    {
      id: 16,
      category: "Canned Food",
      href: "cannedfood",
    },
    {
      id: 17,
      category: "Napkins",
      href: "napkins",
    },
    {
      id: 18,
      category: "Others",
      href: "others",
    },
  ],
};

export default cat;
